import {HttpClient} from '@angular/common/http'
import {inject, Service, signal} from '@angular/core'
import {BehaviorSubject, Observable, tap} from 'rxjs'
import {environment} from '../../environments/environment'
import {User} from './types'
import {toSignal} from '@angular/core/rxjs-interop'

@Service()

export class UserService {
  /**
   * Consumers should listen to this to get the latest user list.
   */
  public users$ = new BehaviorSubject<User[]>([])

  public users = toSignal(this.users$)

  public pOffices = signal<string[]>([])
  public offices = this.pOffices.asReadonly()


  private readonly http = inject(HttpClient)

  public getUsers(update?: boolean): Observable<User[]> {
    let url = `${environment.userServiceUrl}/users`
    if (update === true) {
      url += `?bust=${Date.now()}`
    }
    return this.http.get<User[]>(url)
      .pipe(
        tap(users => {
          this.users$.next(users.toSorted((a, b) =>
            a.name.localeCompare(b.name, 'sv-SE')))
        })
      )
  }

  public getOffices(): Observable<string[]> {
    return this.http.get<string[]>(`${environment.userServiceUrl}/data/offices`)
      .pipe(
        tap(os => this.pOffices.set(os))
      )
  }

  public getUser(sId: string): User {
    return this.users$.value.find((user: User) => user.sId === sId) || {} as User
  }
}
